const getCookie = (cookieName: string): string | undefined => {
  const cookie: { [key: string]: string } = {};
  document.cookie.split(";").forEach((el) => {
    const [key, value] = el.split("=");
    cookie[key.trim()] = value;
  });
  return cookie[cookieName];
};

export { getCookie };
